import { useContext, useEffect, useState } from "react";
import _ from 'lodash';
import { LoaderContext } from "../../../../context/LoaderContext";
import { START_LOADER, STOP_LOADER } from "../../../../constants";
import { momentTimeFormater } from "../../../../utils/timeHelper";
import CustomTooltip from "../../../../components/CustomToolTip/CustomTooltip";
import { UilFileLandscapeAlt, UilLightbulbAlt, UilInfoCircle, UilSync } from '@iconscout/react-unicons';
import Typography from "../../../../components/Typography/Typography";
import Table from "../../../../components/Table/Table";
import ModalComponent from "../../../../components/ModalComponent/ModalComponent";
import CommandLogsModal from "./CommandLogsModal";
import DataLogModal from "./DataLogModal";
import classes from '../../../../styles/AllDevices.module.css';
import monitoringClasses from './index.module.css';
import { EventsService } from "../../../../services/EventsService";
import EventsLogModal from "./EventsLogModal";

const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

const CurrentEvents = ({ }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [events, setEvents] = useState([]);
    const [eventsLogModal, setEventsLogModal] = useState({ status: false, id: '' });
    const [commandLogModal, setCommandLogModal] = useState({ status: false, id: '' });
    const [dataLogModal, setDataLogModal] = useState({ status: false, data: '' });

    useEffect(() => {
        getEvents();
    }, []);

    const getEvents = () => {
        EventsService.GetCurrentEvents(
            () => startLoader('getEvents'),
            handleGetEventsSuccess,
            handleError,
            () => stopLoader('getEvents')
        );
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetEventsSuccess = ({ data }) => {
        const processedData = data?.data?.data?.map((item, index) => {
            return {
                's.no': index + 1,
                customerName: item.customerName,
                instanceName: item.instanceName,
                edgeId: item.edgeId,
                status: item.status,
                SOC: item.soc ?? '--',
                power: item.power ?? '--',
                biddingStatus: item.bidStatus || '--',
                startTime: item.startTime ? momentTimeFormater(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                endTime: item.endTime ? momentTimeFormater(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                action: (
                    <div className={monitoringClasses.ActionContainer}>
                        <div onClick={() => {
                            setEventsLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Event Logs'}>
                                <UilFileLandscapeAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => {
                            setCommandLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Command Logs'}>
                                <UilLightbulbAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => setDataLogModal({ status: true, data: item })}>
                            <CustomTooltip content={'Data Log'}>
                                <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                    </div>
                )
            };
        });
        setEvents(processedData);
    };

    return (
        <div>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content={`Current`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={events.length} />
                            </span>
                        </div>
                    </div>
                    <div onClick={() => {
                        getEvents();
                    }}>
                        <CustomTooltip content={'Refresh'}>
                            <UilSync size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                        </CustomTooltip>
                    </div>
                </div>
                <Table
                    head={[
                        'Customer',
                        'Instance',
                        'Edge ID',
                        'Event Status',
                        'SOC',
                        'Power',
                        'Bidding Status',
                        'Start Time (CET)',
                        'End Time (CET)',
                        'Actions'
                    ]}
                    keys={[
                        'customerName',
                        'instanceName',
                        'edgeId',
                        'status',
                        'SOC',
                        'power',
                        'biddingStatus',
                        'startTime',
                        'endTime',
                        'action'
                    ]}
                    data={events}
                />
            </div>
            <ModalComponent isOpen={eventsLogModal.status} setOpen={() => setEventsLogModal({
                status: false,
                id: '',
            })}>
                <EventsLogModal setOpen={() => setEventsLogModal({ status: false, id: '' })} id={eventsLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={commandLogModal.status} setOpen={() => setCommandLogModal({
                status: false,
                id: '',
            })}>
                <CommandLogsModal setOpen={() => setCommandLogModal({ status: false, id: '' })} id={commandLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={dataLogModal.status} setOpen={() => setDataLogModal({
                status: false,
                data: '',
            })}>
                <DataLogModal setOpen={() => setDataLogModal({ status: false, data: '' })} data={dataLogModal.data} />
            </ModalComponent>
        </div>
    )
}

export default CurrentEvents;